import React from 'react';
import PropTypes from 'prop-types';

class DIBS extends React.Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  componentDidMount() {
    const { form, props } = this;
    // Empty the state to prevent rerendering.
    props.actions.receivedDibsForm([]);

    form.current.submit();
  }

  render() {
    const { dibsFormArgs } = this.props.appearance;

    return (
          <form
            action={dibsFormArgs ? dibsFormArgs.form.action : ''}
            method="POST"
            ref={this.form}
          >
            {dibsFormArgs &&
              Object.keys(dibsFormArgs.form.elements).map(
                element =>
                  dibsFormArgs.form.elements[element] && (
                    <input
                      key={element}
                      name={element}
                      type="hidden"
                      value={dibsFormArgs.form.elements[element]}
                    />
                  )
              )}
          </form>
    );
  }
}

DIBS.PropTypes = {
  appearance:PropTypes.object.isRequired,
  actions:PropTypes.object.isRequired,
};

export default DIBS;
